<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white;">
            <br/>
            <div class="col-sm-10 col-xs-12">
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>รหัสวัตถุดิบ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input placeholder="เช่น MT001"
                               type="text"
                               class="form-control"
                               v-model="form.code"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>รายการวัตถุดิบ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input placeholder="เช่น เม็ดโฟม"
                               type="text"
                               class="form-control"
                               v-model="form.name"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>ประเภทวัตถุดิบ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <b-form-select v-model="form.type" :options="optionType">
                        </b-form-select>
                    </b-col>
                </b-row>
                <br/>
                <b-row v-if="form.type && form.type == 2">
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>ประเภทถุง</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <multiselect
                            v-model="form.type_bag"
                            :show-labels="false"
                            :options="optionBagType"
                            label="name"
                            placeholder="ประเภทถุง"
                            track-by="name">
                        </multiselect>
                        <br/>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>หน่วย</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <b-form-select v-model="form.unit"
                                       :options="unitOption">
                        </b-form-select>
                        <br/>
                    </b-col>
                </b-row>
                <br>
                <!--<b-row>-->
                <!--<b-col sm="4" class="col-sm-4 col-xs-12 text-right">-->
                <!--<label>จำนวน</label>-->
                <!--</b-col>-->
                <!--<b-col sm="6" class="col-sm-6 col-xs-12">-->
                <!--<input-->
                <!--type="number"-->
                <!--class="form-control"-->
                <!--v-model="form.quantity" disabled/>-->
                <!--</b-col>-->
                <!--</b-row>-->
                <!--<br />-->
                <!--<b-row>-->
                <!--<b-col sm="4" class="col-sm-4 col-xs-12 text-right">-->
                <!--<label>ราคา</label>-->
                <!--</b-col>-->
                <!--<b-col sm="6" class="col-sm-6 col-xs-12">-->
                <!--<input-->
                <!--type="text"-->
                <!--class="form-control"-->
                <!--v-model="form.price" disabled/>-->
                <!--</b-col>-->
                <!--</b-row>-->
                <!--<br />-->
                <!--<b-row>-->
                <!--<b-col sm="4" class="col-sm-4 col-xs-12 text-right">-->
                <!--<label>วันหมดอายุ</label>-->
                <!--</b-col>-->
                <!--<b-col sm="6" class="col-sm-6 col-xs-12">-->
                <!--<input-->
                <!--type="date"-->
                <!--class="form-control"-->
                <!--v-model="form.expire_date"/>-->
                <!--</b-col>-->
                <!--</b-row>-->
                <b-row>
                    <b-col sm="4" class="col-sm-4 col-xs-12 text-right">
                        <label>จำนวนขั้นต่ำ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 col-xs-12">
                        <input
                            type="number"
                            class="form-control"
                            v-model="form.min_quantity"/>
                    </b-col>
                </b-row>
                <br/>
                <b-form inline>
                    <label class="col-4"/>
                    <div class="col-sm-6 form-button" style="padding-left: 30px;">
                        <b-button
                            :disabled="form.onSave"
                            variant="success"
                            @click="saveMaterial">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </b-button>
                        &nbsp;&nbsp;
                        <b-button variant="btn btn-outline-secondary"
                                  @click="goToMaterial">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </b-button>
                        &nbsp;&nbsp;
                        <b-button v-if="id && !form.cancel_status"
                                  @click="showDeleteMaterialModal()"
                                  class="btn btn-danger">
                            <icon name="trash-alt" style="width: 25px"></icon>
                            InActive
                        </b-button>
                        <b-button v-else-if="id && form.cancel_status"
                                  @click="showActiveMaterialModal()"
                                  class="btn btn-success">
                            Active
                        </b-button>
                    </div>
                </b-form>
                <br/>
            </div>
            <br/>
        </div>
        <!-- Modal -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteMaterial">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteMaterialModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal -->
        <b-modal hide-header hide-footer ref="active_item">
            <div style="text-align: center;">
                <h4>คุณต้องการเปิดใช้งาน?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="activeMaterial">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideActiveMaterialModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-primary">{{ optionType }}</pre>-->
    </div>
</template>

<script>
import HeaderTitle from "../../HeaderTitle";
import {mapState} from "vuex";
import moment from "moment";
import Multiselect from "vue-multiselect";
import {canViewSuperAdmin} from "../../../util/Permissions";

export default {
    components: {HeaderTitle, Multiselect},
    name: "materials-information",
    props: {
        id: {default: null}
    },
    data() {
        return {
            form: {
                code: "",
                name: "",
                type: "",
                type_bag: "",
                quantity: 0,
                expire_date: "",
                cancel_status: "",
                date: "",
                price: 0,
                min_quantity: 0,
                unit: "",
                onSave: false
            },
            items: [
                {
                    text: "รายการวัตถุดิบ",
                    to: {name: "materials-list"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            unitOption: [
                {
                    value: "",
                    text: "เลือกหน่วย"
                },
                {
                    value: "kg",
                    text: "kg"
                },
                {
                    value: "ใบ",
                    text: "ใบ"
                },
                {
                    value: "กระปุก",
                    text: "กระปุก"
                },
                {
                    value: "แกลอน",
                    text: "แกลอน"
                },
                {
                    value: "ปิ๊บ",
                    text: "ปิ๊บ"
                },
                {
                    value: "ม้วน",
                    text: "ม้วน"
                },
                {
                    value: "โหล",
                    text: "โหล"
                },
                {
                    value: "ลัง",
                    text: "ลัง"
                },
                {
                    value: "มัด",
                    text: "มัด"
                },

            ],
        };
    },
    created() {
        this.getCurrentDate();
        //console.log(this.id);
        this.showMaterial();
        this.$store.dispatch("BagData/getBagType");
        this.$store.dispatch("Common/getMaterialType");
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            data_replace: state => {
                return state.Material.replace_data;
            },
            user: state => {
                return state.Auth.user;
            },
            optionBagType: state => {
                return state.BagData.bag_type
            },
            optionType: state => {
                return [
                    {value: "", text: "กรุณาเลือกประเภทวัตถุดิบ"},
                    ...state.Common.material_type.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ]
            }
        })
    },
    methods: {
        showDeleteMaterialModal() {
            this.$refs.delete_item.show();
        },
        hideDeleteMaterialModal() {
            this.$refs.delete_item.hide();
        },
        showActiveMaterialModal() {
            this.$refs.active_item.show();
        },
        hideActiveMaterialModal() {
            this.$refs.active_item.hide();
        },
        showMaterial() {
            if (this.id) {
                this.$store.dispatch("Material/show", this.id).then(() => {
                    this.form.code = this.data_replace.code;
                    this.form.name = this.data_replace.name;
                    this.form.quantity = this.data_replace.quantity;
                    this.form.expire_date = this.data_replace.expire_date;
                    this.form.min_quantity = this.data_replace.min_quantity;
                    this.form.price = this.data_replace.price;
                    this.form.type = this.data_replace.type;
                    this.form.type_bag = this.data_replace.type_bag;
                    this.form.unit = this.data_replace.unit;
                    this.form.cancel_status = this.data_replace.cancel_status;
                });
            }
        },
        saveMaterial() {
            if (!this.form.code) {
                alert('กรุณาใส่รหัสวัตถุดิบ')
            } else if (!this.form.name) {
                alert('กรุณาใส่ชื่อวัตถุดิบ')
            } else {
                let data = {
                    code: this.form.code,
                    name: this.form.name,
                    type: this.form.type,
                    bag_type_id: "",
                    quantity: this.form.quantity,
                    expire_date: this.form.expire_date,
                    min_quantity: this.form.min_quantity,
                    price: this.form.price,
                    date: this.form.date,
                    unit: this.form.unit,
                    user_id: this.user.id
                };
                if (!this.form.quantity) {
                    this.form.quantity = 0
                }
                if (this.form.type_bag) {
                    data.bag_type_id = this.form.type_bag.id;
                }
                if (this.form.min_quantity < 0) {
                    alert("คุณใส่จำนวนขั้นต่ำไม่ถูกต้อง")
                    this.form.min_quantity = 0;
                } else {
                    this.form.onSave = true;
                    //console.log(this.form)
                    if (this.id) {
                        //update
                        this.$store
                            .dispatch("Material/update", {
                                id: this.id,
                                data: data
                            })
                            .then(() => {
                                this.goToMaterial();
                            }).catch(err => {
                            alert("บันทึกไม่สำเร็จ");
                            this.form.onSave = false;
                        });
                    } else {
                        this.$store.dispatch("Material/create", data).then(() => {
                            this.goToMaterial();
                        }).catch(err => {
                            alert("บันทึกไม่สำเร็จ");
                            this.form.onSave = false;
                        });
                    }
                }
            }
        },
        deleteMaterial() {
            this.$store.dispatch("Material/delete", {id: this.id, user_id: this.user.id}).then(() => {
                this.hideDeleteMaterialModal();
                this.goToMaterial();
            });
        },
        activeMaterial() {
            this.$store.dispatch("Material/active", {id: this.id, user_id: this.user.id}).then(() => {
                this.hideDeleteMaterialModal();
                this.goToMaterial();
            });
        },
        goToMaterial() {
            this.$router.push({name: "materials-list"});
            this.form.onSave = false;
        },
        getCurrentDate() {
            const currentDate = moment().format("YYYY-MM-DD");
            this.form.date = currentDate;
            this.form.expire_date = currentDate;
        }
    }
};
</script>

<style scoped>
.form-button {
    /*margin-left: 20%;*/
    display: flex;
    padding: 0;
}
</style>
